<template>
  <div class="box">
    <div :class="{'hideleft':hide === true,'navbar-collapse':hide === false}" class="left">
      <dl v-for="(list, listidx) in menuList">
        <dt class="z-font-weight-700 z-font-size-12" :class="{'active': listidx === listIndex}" @click.stop="clickList(listidx)">
          <i slot="after" class="arrow iconfont" :class="{'icon-youjiantou rotateDown': listidx === listIndex , 'icon-youjiantou': listidx != listIndex}" style="font-size: 12px;"></i>
          {{list.babel}}
        </dt>
        <dd ref="menuItems" class="menu-items">
          <div v-for="(menu, menuidx) in list.children" :class="{'active': menuidx === menuIndex}" class="menu-item" @click.stop="clickMenu(menu, menuidx)">
            <i class="menu-icon" :class="menu.iconCls"></i>
            {{ menu.babel }}
          </div>
        </dd>
      </dl>
      <div class="viewFramework-product-navbar-collapse" @click.stop="hideList">
        <div class="product-navbar-collapse-inner">
          <div class="product-navbar-collapse-bg z-box-sizing">

          </div>
          <div class="product-navbar-collapse" >
            <span v-if="!hide" class="iconfont icon-collapse-right" style="display: inline"></span>
            <span v-if="hide" class="iconfont icon-collapse-left" style="display: inline"></span>
          </div>
        </div>
      </div>
    </div>
    <router-view :hide="hide" />
  </div>
</template>
<script>
  import userService from 'business/userService.js'
  export default {
    data() {
      return {
        listIndex: 0,
        menuIndex: 0,
        pathList: ['/page1', '/page2', '/page3', '/page4', '/page5', '/page6'],
        menuList: [
          {
            babel: '充值中心',
            children: [
              {
                babel: '充值中心',
                path: '/caiwu',
                iconCls: 'menu-icon-ziliaoxiugai'
              },
            ]
          },
          {
            babel: '收支明细',
            children: [

            ]
          },
          {
            babel: '优惠券',
            children: [

            ]
          },
          {
            babel: '发票管理',
            children: [

            ]
          },
          {
            babel: '消费提成',
            children: [

            ]
          }
        ],
        hide:false,
        is_daili:''
      }
    },
    mounted(){
      this.config()
    },
    watch:{
      '$route' (val) {
        let x,y
        //路由映射
        switch (val['name']) {
          case 'caiwu1':
            x = 0;
            y = 0;
            break;
          case 'caiwu2':
            x = 1;
            y = 0;
            break;
          case 'caiwu1':
            x = 1;
            y = 0;
            break;
          case 'voucher':
            x = 2;
            y = 0;
            break;
          case 'caiwu3':
          case 'caiwu4':
            x = 3;
            y = 0;
            break;
          case 'invoicelist':
            x = 3;
            y = 1;
            break;
          case 'invoiceinfo':
          case 'invoiceadd':
          case 'invoiceedit':
            x = 3;
            y = 2;
            break;
          case 'client':
            x = 4;
            y = 0;
            break;
          case 'bill':
            x = 4;
            y = 1;
            break;
        }
        Array.from(this.$refs.menuItems).forEach((item, inx)=>{
          if( inx === x ) {
            item.style.height = this.menuList[x].children.length * 40 + 'px'
          }else {
            item.style.height = '0px'
          }
        })
        this.menuIndex = y
        sessionStorage.setItem('secondMenu',x)
        sessionStorage.setItem('threeMenu',y)
      }
    },
    methods:{
      async config() {
        await this.getMenu()
        let secondMenu = sessionStorage.getItem('secondMenu') ? sessionStorage.getItem('secondMenu') : 0
        let threeMenu = sessionStorage.getItem('threeMenu') ? sessionStorage.getItem('threeMenu') : 0
        Array.from(this.$refs.menuItems).forEach((item, inx)=>{
          if( inx === Number(secondMenu) ) {
            item.style.height = this.menuList[secondMenu].children.length * 40 + 'px'
          }else {
            item.style.height = '0px'
          }
        })
        this.listIndex = Number(secondMenu)
        this.menuIndex = Number(threeMenu)
      },
      clickList(idx,midx = 0) {
        this.listIndex = idx
        this.menuIndex = midx
        Array.from(this.$refs.menuItems).forEach((item, inx)=>{
          if( inx === idx ) {
            item.style.height = this.menuList[idx].children.length * 40 + 'px'
          }else {
            item.style.height = '0px'
          }
        })
        this.$router.push(this.menuList[this.listIndex]['children'][0]['path'])
      },
      async getMenu() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          if(vueData.msg.is_daili == 0){
            this.menuList = [
              {
                babel: '充值中心',
                children: [
                  {
                    babel: '充值中心',
                    path: '/caiwu',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '收支明细',
                children: [
                  {
                    babel: '收支明细',
                    path: '/caiwu2',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '优惠券',
                children: [
                  {
                    babel: '优惠券',
                    path: '/voucher',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '发票管理',
                children: [
                  {
                    babel: '发票申请',
                    path: '/caiwu3',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                  {
                    babel: '发票列表',
                    path: '/invoicelist',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                  {
                    babel: '发票信息管理',
                    path: '/invoiceinfo',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '消费提成',
                children: [
                  {
                    babel: '拉新佣金',
                    path: '/client',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              }
            ]
          }
          if(vueData.msg.is_daili == 1){
            this.menuList = [
              {
                babel: '充值中心',
                children: [
                  {
                    babel: '充值中心',
                    path: '/caiwu',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '收支明细',
                children: [
                  {
                    babel: '收支明细',
                    path: '/caiwu2',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '优惠券',
                children: [
                  {
                    babel: '优惠券',
                    path: '/voucher',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '发票管理',
                children: [
                  {
                    babel: '发票申请',
                    path: '/caiwu3',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                  {
                    babel: '发票列表',
                    path: '/invoicelist',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                  {
                    babel: '发票信息管理',
                    path: '/invoiceinfo',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
              {
                babel: '消费提成',
                children: [
                  {
                    babel: '拉新佣金',
                    path: '/client',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                  {
                    babel: '消费提成',
                    path: '/bill',
                    iconCls: 'menu-icon-ziliaoxiugai'
                  },
                ]
              },
            ]
          }
        }else {

        }
      },
      clickMenu(menu, idx) {
        this.menuIndex = idx
        this.$router.push(this.menuList[this.listIndex]['children'][idx]['path'])
      },
      hideList(){
        this.hide = !this.hide
      }
    }
  }
</script>
<style scoped>
  .hideleft{ left: -60px; }
  .rotateDown {
    transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
  }
  .menu-items { transition: height .3s; overflow: hidden;}

  .menu-item { padding-left: 46px; line-height: 40px; cursor: pointer; transition: all .1s;}
  .menu-item { font-size: 12px;color: #333; position: relative; }
  .menu-item.active, .menu-item:hover { background: #fff; }
  .menu-item .menu-icon { display: inline-block; width: 17px; height: 16px; position: absolute; left:15px; top:12px; }
  .menu-icon-ziliaoxiugai { background-image: url(../assets/imgs/menu-icon.png)}
  .active .menu-icon-ziliaoxiugai { background-image: url(../assets/imgs/menu-icon-lan.png)}
  .arrow {
    position: absolute;
    left: 17px;
    top: 1px;
    transition: transform 0.3s;
    -moz-transition: -moz-transform 0.3s;
    -ms-transition: -ms-transform 0.3s;
    -webkit-transition: -webkit-transform 0.3s;
    -o-transition: -o-transform 0.3s;
  }

  .viewFramework-product-navbar-collapse{position:absolute;left:140px;top:50%;width:20px;height:50px;z-index:3;-o-transition:all 0.2s ease;-ms-transition:all 0.2s ease;-moz-transition:all 0.2s ease;-webkit-transition:all 0.2s ease}
  .viewFramework-product-navbar-collapse:hover .product-navbar-collapse{left:0}
  .viewFramework-product-navbar-collapse:hover .product-navbar-collapse-bg{border-bottom:8px solid transparent;border-left:20px solid #D9DEE4;border-top:8px solid transparent}
  .viewFramework-product-navbar-collapse .product-navbar-collapse-inner{top:-50%;position:relative;overflow:hidden}
  .viewFramework-product-navbar-collapse .product-navbar-collapse{height:50px;position:relative;left:-7px;text-align:center;cursor:pointer;-o-transition:all 0.1s ease,0.1s ease;-ms-transition:all 0.1s ease,0.1s ease;-moz-transition:all 0.1s ease,0.1s ease;-webkit-transition:all 0.1s ease,0.1s ease}
  .viewFramework-product-navbar-collapse .product-navbar-collapse>span{font-size:15px;line-height:50px;vertical-align:text-top}
  .viewFramework-product-navbar-collapse .product-navbar-collapse-bg{width:0;height:50px;position:absolute;top:0;left:0;border-bottom:9px solid transparent;border-left:13px solid #D9DEE4;border-top:9px solid transparent;-o-transition:all 0.1s ease,0.1s ease;-ms-transition:all 0.1s ease,0.1s ease;-moz-transition:all 0.1s ease,0.1s ease;-webkit-transition:all 0.1s ease,0.1s ease}
  .viewFramework-product-navbar-collapse .icon-collapse-left{display:none}
  .viewFramework-product-navbar-collapse .icon-collapse-right{display:inline}
  .navbar-collapse .viewFramework-product-navbar-collapse{left:119px}
  .navbar-collapse .viewFramework-product-navbar-collapse .product-navbar-collapse{right:-7px;left:auto}
  .navbar-collapse .viewFramework-product-navbar-collapse .product-navbar-collapse>span{color:#546478}
  .navbar-collapse .viewFramework-product-navbar-collapse .product-navbar-collapse-bg{right:0;left:auto;border-bottom:9px solid transparent;border-left:none;border-right:13px solid #f7f7f7;border-top:9px solid transparent;}
  .navbar-collapse .viewFramework-product-navbar-collapse:hover .product-navbar-collapse{right:0;left:auto}
  .navbar-collapse .viewFramework-product-navbar-collapse:hover .product-navbar-collapse-bg{border-bottom:8px solid transparent;border-left:none;border-right:20px solid #f7f7f7;border-top:8px solid transparent}
</style>



// WEBPACK FOOTER //
// src/pages/caiwu.vue